export default __webpack_public_path__ + "static/media/undraw_education.54e3bc34.svg";